import React, { ReactElement, useContext, useState } from 'react'
import DropDown from '@/components/ui/wizard/filter/DropDown'
import { useWizardSelector } from '@/components/ui/wizard/WizardState'
import { useDispatch } from 'react-redux'
import { ConfigContext } from '@/components/common/ConfigContext'
import { Currency } from '@/types/Page'
import FilterLabel from '@/components/ui/wizard/filter/FilterLabel'
import { setMaximumPrice } from '@/components/ui/wizard/WizardActions'
import { useTranslations } from 'next-intl'

export function PriceDropDown(props: { currency: Currency }): ReactElement {
  const maximumPriceInStore = useWizardSelector((state) => state.maximumPrice)
  const [maximumPrice, setMaximumPriceLocalState] = useState(maximumPriceInStore)
  const dispatch = useDispatch()
  const t = useTranslations('SearchPage')

  if (!props.currency) {
    return <></>
  }

  return (
    <DropDown
      reset={() => setMaximumPriceLocalState(undefined)}
      apply={() => dispatch(setMaximumPrice(maximumPrice))}
      resetLabel={t('filterOptionReset')}
      id="price"
    >
      <Price
        maximumPrice={maximumPrice}
        setMaximumPriceLocalState={setMaximumPriceLocalState}
        currency={props.currency}
      />
    </DropDown>
  )
}

export default function Price(props: {
  maximumPrice: string | undefined
  setMaximumPriceLocalState: (p: string) => void
  currency: Currency
}): ReactElement {
  const config = useContext(ConfigContext)!
  const priceList = config.searchFilters.price[props.currency]
  const currentIndex = priceList.findIndex((v) => v === props.maximumPrice)
  const t = useTranslations('SearchPage')
  const tSort = useTranslations('SearchPage.SortCriteria')

  function getBackgroundSize(val: number, max: number): string {
    return ((val * 100) / max).toString() + '% 100%'
  }

  function getValue(): number {
    return currentIndex !== -1 ? currentIndex : getMaxIndex()
  }

  function getMaxIndex(): number {
    return priceList.length - 1
  }

  return (
    <div className="mb-6 text-left">
      <FilterLabel label="SearchPage.labelPrice" />
      <label className="text-left text-xs text-stone-600"> {t('labelMaxPrice')}</label>
      <div className="text-left text-xl font-medium text-stone-800">
        {getMaxIndex() === currentIndex || currentIndex === -1
          ? tSort('priceAnyPrice')
          : props.maximumPrice || priceList[getMaxIndex()]}
      </div>
      <input
        type="range"
        className="w-full"
        autoComplete="off"
        min="0"
        max={getMaxIndex()}
        value={getValue()}
        id="custom-slider"
        style={{ backgroundSize: getBackgroundSize(getValue(), getMaxIndex()) }}
        onChange={(e) => {
          props.setMaximumPriceLocalState(priceList[+e.target.value])
        }}
      />
      <div className="flex w-full justify-between">
        <div className="text-xs text-stone-600">{priceList[0]}</div>
        <div className="text-xs text-stone-600">{priceList[getMaxIndex()]}</div>
      </div>
    </div>
  )
}
